// @flow

export type Chapter = {
  title: string,
  text: string,
  mapbox: any
}

export const chapters: Array<Chapter> = [
  {
    gdocId: 'bergen-oversikt',
    title: 'Bergen, laurdag 7. januar 2017',
    text: 'Bergen sentrum, det er natt til laurdag 7. januar 2017. På eit lite geografisk område, alt med gangavstand, skal fem valdstilfelle til å skje. Klokka bikkar tolv.',
    fallbackPicture: '1.14306106',
    mapbox: {
      id: 'bergen-oversikt',
      duration: 7000,
      center: [5.322830, 60.391191],
      // bounds: [[2, 40], [12, 65]],
      zoom: 13,
      pitch: 0,
      bearing: 0,
      mapColor: 'dark'
    }
  }, {
    gdocId: 'forste-tilfelle',
    title: 'Ca. 00:00',
    text: 'Ein mann (23) og kameraten går av bussen. Dei skal vidare til Loddefjord, men slik blir det ikkje.<br/><br/>Klokka 00:17 får politiet melding: Ein mann (23) skal ha komme i samanstøyt med 17-åringane. Først roping, deretter barka dei saman, midt i gata. 17-åringane følgde etter då dei to andre trekte seg tilbake. Dei skal ha slått og sparka mot kroppen og hovudet på 23-åringen, og han låg livlaus på bakken då dei to sprang vidare. Han blødde frå nasen, hadde ein kul i hovudet, og i ettertid sleit han med hovudverk.',
    fallbackPicture: '1.14306127',
    textAlign: 'left',
    mapbox: {
      id: 'hentiesbay',
      duration: 7000,
      center: [5.326523780822754, 60.393102034485416],
      // bounds: [[2, 40], [12, 65]],
      zoom: 18,
      bearing: 20,
      pitch: 0,
      point: {
        'name': 'navn',
        'lat': 60.393102034485416,
        'lon': 5.326523780822754
      }
    }
  }, {
    gdocId: 'andre-tilfelle',
    title: 'Ca. 00:15',
    text: 'Ein mann i 50-åra har vore inne og sett på TV, og går ut for å bestille seg ein pizza. Medan han ventar på maten tar han seg ein tur til Torgallmenningen.<br/><br/>Ved McDonalds går mannen litt til sida for å gå forbi to gutar som han får inntrykk av at er gira. Ifølge vitne yppar 17-åringane, drar mannen til sida, og deretter går Benjamin roleg bort til mannen, gjer ei dreiing med kroppen, og slår til mannen i hovudet med olbogen. Mannen landar på bakken med heile kroppen samtidig, og smell hovudet i asfalten. Eit vitne seier det såg ut som om mannen ikkje var medviten då han landa.',
    fallbackPicture: '1.14306128',
    textAlign: 'left',
    mapbox: {
      id: 'durban',
      duration: 7000,
      center: [5.323251485824585, 60.39248186488759],
      bearing: 0,
      zoom: 18,
      pitch: 15,
      point: {
        'name': 'navn2',
        'lat': 60.39248186488759,
        'lon': 5.323251485824585
      }
    }
  }, {
    gdocId: 'tredje-tilfelle',
    title: 'Ca. 00:17',
    text: 'Ein mann (21) har vore på McDonalds med ein kamerat. Dei ser ein mann ligge livlaus på bakken, og dei oppfattar at nokon skrik og hoiar. Dei tenker det er nok folk som hjelper mannen, og går vidare mot ein utestad.<br><br>I det dei kryssar vegen mot Xhibition kjem ein person skrått inn og seier «Do you have a problem». 21-åring svarar «Nei», og han blir han skalla i ansiktet. Den som skallar han ned er Benjamin. 21-åringen får eit kutt i augebrynet.',
    fallbackPicture: '1.14306129',
    textAlign: 'left',
    mapbox: {
      id: 'tromso',
      duration: 6000,
      center: [5.325295329093933, 60.39263823354951],
      bearing: 0,
      zoom: 18,
      pitch: 0,
      mapColor: 'red',
      point: {
        'name': 'navn3',
        'lat': 60.39263823354951,
        'lon': 5.325295329093933
      }
    }
  }, {
    gdocId: 'fjerde-tilfelle',
    title: 'Ca. 00:45',
    text: 'Ein mann (18) har vore med ein gjeng kjøpt seg kebab. På veg ut møter dei 17-åringane. Ein av dei to brukar skuldra til å dulte borti ein i gjengen. 18-åringen spør kvifor han gjorde det. «Er det eit problem med det», svarar den eine 17-åringen. «Ja», svarer 18-åringen.<br><br>Benjamin sitt svar til det er å slå, og han tar kvelartak på den andre. Petter kjem springande til, og skal ha dradd eller kasta 18-åringen i bakken. Deretter prøver Petter å slå̊ 18-åringen i ansiktet og på kroppen.',
    fallbackPicture: '1.14306131',
    textAlign: 'left',
    mapbox: {
      id: 'kristiansand',
      duration: 6000,
      center: [5.32213568687439, 60.390769711427204],
      bearing: 0,
      zoom: 18,
      pitch: 0,
      mapColor: 'red',
      point: {
        'name': 'navn3',
        'lat': 60.390769711427204,
        'lon': 5.32213568687439
      }
    }
  }, {
    gdocId: 'femte-tilfelle',
    title: 'Ca. 00:47',
    text: 'Nokon i gjengen kjem inn på kebabsjappa, og seier til dei som sit der at nokon køddar med ein kamerat av dei.<br><br>Ein av dei som er inne går ut og spør kva som skjer. Benjamin slår til han, med knytt hand, i ansiktet, og dyttar han over ende. Benjamin slår gjentatte gonger mot hovudet og kroppen til mannen. Den fornærma skal ha forklart i retten at han visste kven den eine av dei to 17-åringane var.',
    fallbackPicture: '1.14306133',
    textAlign: 'left',
    mapbox: {
      id: 'oslo',
      duration: 6000,
      center: [5.32207568687439, 60.390769711427204],
      bearing: 0,
      zoom: 18.6,
      pitch: 20,
      mapColor: 'red',
      point: {
        'name': 'navn4',
        'lat': 60.390769711427204,
        'lon': 5.32207568687439
      }
    }
  }, {
    gdocId: 'paagripinga',
    title: 'Ca. 02:23',
    text: 'Petter blir pågripen og blir tatt med til arresten. Benjamin blir ikkje arrestert denne natta.',
    fallbackPicture: '1.14306135',
    textAlign: 'left',
    mapbox: {
      id: 'birmingham',
      duration: 6000,
      center: [5.3260087966918945, 60.393147089081396],
      bearing: 0,
      zoom: 16.5,
      pitch: 0,
      mapColor: 'red',
      point: {
        'name': 'navn5',
        'lat': 60.393147089081396,
        'lon': 5.3260087966918945
      }
    }
  }, {
    gdocId: 'slutt-oversikt',
    title: '',
    text: 'Fem tilfelle, frå klokka litt over tolv til litt før eitt. Mindre enn ein time. To 17-åringar, og fem som er skadd av vald.',
    fallbackPicture: '1.14306136',
    textAlign: 'left',
    mapbox: {
      id: 'birmingham',
      duration: 8000,
      center: [5.322830, 60.391191],
      bearing: 0,
      zoom: 14,
      pitch: 0,
      mapColor: 'red'
    }
  }
]

export function createChapters (): Array<Chapter> {
  return chapters.map(chapter => {
    return { ...chapter }
  })
}



// WEBPACK FOOTER //
// ./src/v1/components/chapters.js